module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-form', {
    ref: "form",
    attrs: {
      "model": _vm.form,
      "label-width": "120px"
    },
    nativeOn: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.onSubmit($event)
      }
    }
  }, [_c('el-row', {
    attrs: {
      "gutter": 30
    }
  }, [_c('el-col', {
    attrs: {
      "span": 19
    }
  }, [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "box__header"
  }, [_c('span', {
    staticClass: "box__header--text"
  }, [_vm._v(_vm._s(_vm.getRouteName(_vm.$route)))]), _vm._v(" "), _c('form-language-switcher')], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Nazwa galerii",
      "error": _vm.errors[_vm.addLanguageSuffix('name')],
      "required": ""
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.form[_vm.addLanguageSuffix('name')]),
      callback: function($$v) {
        _vm.$set(_vm.form, _vm.addLanguageSuffix('name'), $$v)
      },
      expression: "form[addLanguageSuffix('name')]"
    }
  })], 1), _vm._v(" "), _c('edition-input', {
    attrs: {
      "errors": _vm.errors.edition,
      "required": true
    },
    model: {
      value: (_vm.form.edition),
      callback: function($$v) {
        _vm.$set(_vm.form, "edition", $$v)
      },
      expression: "form.edition"
    }
  })], 1), _vm._v(" "), _c('gallery-images', {
    attrs: {
      "images": _vm.form.images
    },
    on: {
      "update:images": function($event) {
        return _vm.$set(_vm.form, "images", $event)
      }
    }
  })], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 5
    }
  }, [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "box__header"
  }, [_vm._v("\n                        " + _vm._s(_vm.$t('manage')) + "\n                    ")]), _vm._v(" "), _c('el-form-item', {
    staticClass: "form__buttons",
    attrs: {
      "label-width": "0"
    }
  }, [_c('router-link', {
    attrs: {
      "to": _vm.redirectRoute
    }
  }, [_c('el-button', {
    staticClass: "fluid form__button"
  }, [_vm._v(_vm._s(_vm.$t('cancel')))])], 1), _vm._v(" "), _c('el-button', {
    staticClass: "fluid form__button",
    attrs: {
      "type": "primary",
      "loading": _vm.loading
    },
    on: {
      "click": _vm.onSubmit
    }
  }, [_vm._v("\n                            " + _vm._s(_vm.$t('submit')) + "\n                        ")])], 1)], 1)])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-620a0f9a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/Gallery/Galleries/GalleryForm.vue
// module id = 769
// module chunks = 0